// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add these styles to your CSS file */
.delete-btn {
  background-color: red;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

/* Custom pop-up styles */
.custom-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.custom-popup h2 {
  margin-top: 0;
}

.custom-popup-buttons {
  margin-top: 20px;
  text-align: right;
}

.custom-popup-buttons button {
  margin-left: 10px;
}
/* Add these styles to your CSS file */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.update-btn {
  background-color: blue;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

.delete-btn {
  background-color: red;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

/* Custom pop-up styles */
.custom-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.custom-popup h2 {
  margin-top: 0;
}

.custom-popup-buttons {
  margin-top: 20px;
  text-align: right;
}

.custom-popup-buttons button {
  margin-left: 10px;
}

/* Add space between buttons */
.button-space {
  margin: 0 6px;
}
/* Add these styles to your CSS file */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.update-btn {
  background-color: blue;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

.delete-btn {
  background-color: red;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

/* Custom pop-up styles */
.custom-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.custom-popup h2 {
  margin-top: 0;
}

.custom-popup-buttons {
  margin-top: 20px;
  text-align: right;
}

.custom-popup-buttons button {
  margin-left: 10px;
}

/* Add space between buttons */
.button-space {
  margin: 0 4px;
}
/* Add these styles to your CSS file */
.custom-popup-buttons button {
  margin-left: 10px;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.custom-popup-buttons button.cancel-btn {
  background-color: #ccc;
  color: #333;
}

.custom-popup-buttons button.delete-btn {
  background-color: red;
  color: white;
}

.table-container {
  overflow-x: auto;
  width: 100%;
  /* Optional: to ensure the table takes up the full width */
  display: block;
}

table {
  width: 100%;
  border-collapse: collapse;
  /* Ensure the table stretches to fit its container */
}

thead th {
  font-size: 13px;
  padding: 10px;
  background: #f5f7fb;
  color: #989898;
  /* Ensures header text is centered and has a consistent height */
  text-align: center;
}

@media (max-width: 0px) {
  thead {
    display: none; /* Hides the header for small screens */
  }

  tr {
    display: block;
    margin-bottom: 10px;
    /* Stack table rows for small screens */
  }

  td {
    display: flex;
    justify-content: space-between;
    /* Make table cells flex items for better control */
    padding: 10px;
    /* Add padding for better readability */
    border-bottom: 1px solid #ddd;
    /* Add a border for visual separation */
  }

  td::before {
    content: attr(data-label);
    font-weight: bold;
    /* Add labels before cell content for better context */
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/AdminDashboard/pages/UserCampign/UserCampign.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;AACA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa,EAAE,uCAAuC;EACxD;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mDAAmD;IACnD,aAAa;IACb,uCAAuC;IACvC,6BAA6B;IAC7B,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,sDAAsD;IACtD,cAAc;EAChB;AACF","sourcesContent":["/* Add these styles to your CSS file */\r\n.delete-btn {\r\n  background-color: red;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Custom pop-up styles */\r\n.custom-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.custom-popup h2 {\r\n  margin-top: 0;\r\n}\r\n\r\n.custom-popup-buttons {\r\n  margin-top: 20px;\r\n  text-align: right;\r\n}\r\n\r\n.custom-popup-buttons button {\r\n  margin-left: 10px;\r\n}\r\n/* Add these styles to your CSS file */\r\n.button-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.update-btn {\r\n  background-color: blue;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-btn {\r\n  background-color: red;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Custom pop-up styles */\r\n.custom-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.custom-popup h2 {\r\n  margin-top: 0;\r\n}\r\n\r\n.custom-popup-buttons {\r\n  margin-top: 20px;\r\n  text-align: right;\r\n}\r\n\r\n.custom-popup-buttons button {\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Add space between buttons */\r\n.button-space {\r\n  margin: 0 6px;\r\n}\r\n/* Add these styles to your CSS file */\r\n.button-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.update-btn {\r\n  background-color: blue;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-btn {\r\n  background-color: red;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Custom pop-up styles */\r\n.custom-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.custom-popup h2 {\r\n  margin-top: 0;\r\n}\r\n\r\n.custom-popup-buttons {\r\n  margin-top: 20px;\r\n  text-align: right;\r\n}\r\n\r\n.custom-popup-buttons button {\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Add space between buttons */\r\n.button-space {\r\n  margin: 0 4px;\r\n}\r\n/* Add these styles to your CSS file */\r\n.custom-popup-buttons button {\r\n  margin-left: 10px;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-popup-buttons button.cancel-btn {\r\n  background-color: #ccc;\r\n  color: #333;\r\n}\r\n\r\n.custom-popup-buttons button.delete-btn {\r\n  background-color: red;\r\n  color: white;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n  /* Optional: to ensure the table takes up the full width */\r\n  display: block;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  /* Ensure the table stretches to fit its container */\r\n}\r\n\r\nthead th {\r\n  font-size: 13px;\r\n  padding: 10px;\r\n  background: #f5f7fb;\r\n  color: #989898;\r\n  /* Ensures header text is centered and has a consistent height */\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 0px) {\r\n  thead {\r\n    display: none; /* Hides the header for small screens */\r\n  }\r\n\r\n  tr {\r\n    display: block;\r\n    margin-bottom: 10px;\r\n    /* Stack table rows for small screens */\r\n  }\r\n\r\n  td {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    /* Make table cells flex items for better control */\r\n    padding: 10px;\r\n    /* Add padding for better readability */\r\n    border-bottom: 1px solid #ddd;\r\n    /* Add a border for visual separation */\r\n  }\r\n\r\n  td::before {\r\n    content: attr(data-label);\r\n    font-weight: bold;\r\n    /* Add labels before cell content for better context */\r\n    display: block;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
